import { Injectable } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { GroupDetails } from '@shared/interfaces/group-details';

@Injectable({
  providedIn: 'root'
})
export class GroupBasedAccessService {
  constructor(private authService: AuthService) {}

  isUserPartOfGroup(groupDetails: GroupDetails) {
    return new Promise((resolve, reject) => {
      this.authService.getUserGroupsAPIM().then((APIMGroups: string[]) => {
        let found;
        if (groupDetails.inAnyOfGroup) {
          found = APIMGroups.some(g => groupDetails.inAnyOfGroup.includes(g));
        } else {
          found = groupDetails.inAllGroups.every(i => APIMGroups.includes(i));
        }
        if (found) {
          resolve(found);
        } else {
          reject();
        }
      });
    });
  }
}
